<script setup lang="ts">
import type { SwitchIssueDetail } from '@/components/building-block-form/utils/buildingBlockCardUtils'

defineProps<{
  issueTitle: string
  issueBadgeColor: string
  missingDetails: SwitchIssueDetail[]
  changedDetails: SwitchIssueDetail[]
}>()
</script>

<template>
  <div class="switch-issue-details mt-1">
    <v-chip size="x-small" :color="issueBadgeColor" variant="tonal" class="mr-2 mb-1">
      {{ issueTitle }}
    </v-chip>
    <div
      v-for="(detail, index) in missingDetails"
      :key="`missing-${index}`"
      class="switch-issue-text"
    >
      {{ detail.summary }}
    </div>
    <div
      v-for="(detail, index) in changedDetails"
      :key="`changed-${index}`"
      class="switch-issue-text mb-1"
    >
      <div>{{ detail.summary }}</div>
      <div
        v-for="(fieldDiff, fieldIndex) in detail.fieldDiffs"
        :key="`changed-${index}-field-${fieldIndex}`"
        class="switch-issue-subtext"
      >
        {{ fieldDiff }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.switch-issue-details {
  line-height: 1.3;
}

.switch-issue-text {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.78);
}

.switch-issue-subtext {
  font-size: 0.75rem;
  opacity: 0.9;
  margin-left: 8px;
}
</style>
